import { useContext } from 'react';
import { FeatureFlagContext } from '../contexts/FeatureFlagContext';

// ----------------------------------------------------------------------

const useFeatureFlags = () => {
  const context = useContext(FeatureFlagContext);

  if (!context) throw new Error('useFeatureFlags must be used inside FeatureFlagProvider');

  return context;
};

export default useFeatureFlags;
